import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import {AgentModel} from "../../models/agent.model";
import {ServiceType} from "../../../../deliveries/types/service.type";

require('./agents-list-item.scss');
@Component({
  standalone: false,
  selector: 'app-agents-list-item',
  templateUrl: './agents-list-item.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentsListItemComponent implements OnInit, OnChanges {

  @Input() agent: AgentModel;
  @Input() isSelected: boolean;
  @Input() isItineraryMode: boolean;
  @Input() enableItineraryButton: boolean;
  @Input() enableDriverButton: boolean;
  @Input() enableChangeDriverStatus: boolean;
  @Input() isMinimizedData: boolean;

  @Output() onAgentSelect = new EventEmitter<AgentModel>();
  @Output() onItineraryClick = new EventEmitter<AgentModel>();
  @Output() onChangeStatus = new EventEmitter<null>();

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  protected readonly ServiceType = ServiceType;
}
